import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=16b0aa66&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b0aa66')) {
      api.createRecord('16b0aa66', component.options)
    } else {
      api.reload('16b0aa66', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=16b0aa66&", function () {
      api.rerender('16b0aa66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/handling/Index.vue"
export default component.exports